export type TypeEventWithOriginalEvent<TEvent extends Event = Event> = TEvent & {
    originalEvent?: TEvent;
};

// ----------------------------------------------------------------------------

function getOriginalEvent<TEvent extends Event>(evt: TypeEventWithOriginalEvent<TEvent>): TEvent {
    return evt.originalEvent ?? evt;
}

// ----------------------------------------------------------------------------

export default getOriginalEvent;
